import { useState } from 'react';
import { BASE_URL } from '../utility/constants';
import { axiosInstance } from '../services/axiosConfig';

const useFileUpload = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const uploadFile = async ({ file, fileName, fileFolder }) => {
    setIsLoading(true);
    setResponse(null);
    setError(null);
    
    try {
      const formData = new FormData();
      formData.append('file', file);

      const res = await axiosInstance.post(
        `${BASE_URL}v1/files/upload-file?file_name=${fileName}&file_folder=${fileFolder}`,
        formData,
        {
          headers: { 
            'Content-Type': 'multipart/form-data'
          },
        }
      );
      setResponse(res.data);
      return res.data; // Return the response data
    } catch (err) {
      setError(err);
      throw err; // Re-throw the error
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setResponse(null);
    setError(null);
    setIsLoading(false);
  };

  return { response, error, isLoading, uploadFile, reset };
};

export default useFileUpload; 